import React, { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import theme from '../constants/Theme';

interface HeadlineProps {
  children: ReactNode;
  fontSize?: number;
  marginBottom?: number;
}

const Headline: React.FC<HeadlineProps> = ({ children, fontSize = 24, marginBottom = 24 }) => {
  const classes = useStyles({ fontSize, marginBottom });

  return <h1 className={classes.headline}>{children}</h1>;
};

type StyleProps = {
  fontSize: number;
  marginBottom: number;
};

const useStyles = createUseStyles({
  headline: (props: StyleProps) => ({
    marginTop: 0,
    marginBottom: props.marginBottom,
    position: 'relative',
    fontSize: props.fontSize,
    letterSpacing: -0.5,
    fontFamily: theme.typography.fontFamily,
    color: theme.colors.blue,
    textAlign: 'left',
  }),
});

export default Headline;
